import { render } from "./VideoWallLayoutButton.vue?vue&type=template&id=de10a6dc&ts=true"
import script from "./VideoWallLayoutButton.vue?vue&type=script&lang=ts"
export * from "./VideoWallLayoutButton.vue?vue&type=script&lang=ts"

import "./VideoWallLayoutButton.vue?vue&type=style&index=0&id=de10a6dc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__